export default __webpack_public_path__ + "static/media/q13_v2.e897fcbe.png";